/*
* 全家常量枚举
* */
CONSTS = {
  SERVERURL: 'https://umbrella.ituzhi.com/api',   //接口地址
  //SERVERURL: 'http://service.ituzhi.com',
  //SERVERURL: 'http://192.168.1.181:8088',
  SITETITLE: "云南招商地图",
  SITELOGINTITLE: "云南招商地图",
}
